import React, { Component } from 'react';

class Postponement extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <section className="postponement-inner">
                <h3>PCD@Coimbra Postponement</h3>
                <div className="postponement-into">
                    <p>One of the goals of PCD@Coimbra is to foster discussion on future directions of the field. At this
                    moment, there is no discussion on what has to be done: reduce social contact and stay home to avoid
                        further spread of the COVID-19 virus.</p>

                    <p>For this reason, the PCD@Coimbra organising team considers its responsibility to postpone the event
                        to a later date in which we can all meet without the fear of harming each other.</p>

                    <p>For those who submitted posters, worry not: the selection process will happen as planned. In fact,
                        your amazing posters are already on their way to the jury.</p>

                    <p>The PCD@Coimbra organising team will continue to closely follow the evolution of the COVID-19
                        pandemic and will keep you updated on future developments.</p>

                    <p>Until then, stay home and stay safe.</p>
                </div>
            </section>
        );
    }
}

export default Postponement;